import { Button, Tag } from 'antd';
import { Plus } from 'lucide-react';
import { ComplianceDocumentHistory } from '../../components/ComplianceDocumentHistory';
import { DOCUMENT_STATUS_LABELS } from '../../components/document-status-labels';
import type { ComplianceDocumentView } from '../../lib/compliance-documents';

interface DriverDocumentRowProps {
  document: ComplianceDocumentView;
  canManage: boolean;
  onDownload: (documentId: string) => void;
  onAct: (document: ComplianceDocumentView) => void;
}

/** One document type — its current document (or "missing"), an Add/Renew button, and a history disclosure. No "Uploaded by": the audit trail already carries who. */
export function DriverDocumentRow({ document, canManage, onDownload, onAct }: DriverDocumentRowProps) {
  const status = DOCUMENT_STATUS_LABELS[document.status];
  const current = document.current;
  const history = document.history.filter((entry) => entry.id !== current?.id);

  return (
    <li className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <div>
          {current ? (
            <button type="button" className="font-medium text-link hover:underline" onClick={() => onDownload(current.id)}>
              {document.documentTypeName}
            </button>
          ) : (
            <p className="font-medium text-fg">{document.documentTypeName}</p>
          )}
          <p className="text-sm text-muted">{current ? `Expires ${new Date(current.expiryDate).toLocaleDateString()}` : 'Not attached'}</p>
        </div>
        <div className="flex items-center gap-3">
          <Tag color={status.color}>{status.label}</Tag>
          {canManage && (
            <Button size="small" icon={<Plus className="size-3.5" />} onClick={() => onAct(document)}>
              {current ? 'Renew' : 'Add'}
            </Button>
          )}
        </div>
      </div>
      <ComplianceDocumentHistory entries={history} onOpen={onDownload} />
    </li>
  );
}
